"use strict";

var _interopRequireWildcard = require("/opt/jenkins/workspace/sit-app-client/node_modules/@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var util = _interopRequireWildcard(require("@/utils/util"));

//
//
//
//
//
//
var _default = {
  name: 'App',
  mounted: function mounted() {
    var theme = util.getSystemTheme();

    if (theme === 'dark') {
      document.body.setAttribute('data-theme', 'dark');
      document.body.style.backgroundColor = '#161A22'; // 页面高度不足100vh时，避免底色为body的背景色
    }
  }
};
exports.default = _default;